export default __webpack_public_path__ + "static/media/sayhan.112c7990.jpg";